import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PagePropertiesReportRenderer } from '@confluence/page-properties-report-renderer';
import type { ComponentProps } from 'react';

export const DetailsSummaryExtensionHandler: LoadableType<{
	macroDefaultProps: ExtensionHandlerProps;
	macroParams?: ComponentProps<typeof PagePropertiesReportRenderer>['macroParams'];
	openAnchorsInNewTab?: boolean;
	Renderer?: any;
	isLegacyRenderer?: boolean;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DetailsSummaryExtensionHandler" */ '../src/DetailsSummaryExtensionHandler.tsx'
			)
		).DetailsSummaryExtensionHandler,
});
